import { render, staticRenderFns } from "./SitemapCategory.vue?vue&type=template&id=540a974e&scoped=true&"
import script from "./SitemapCategory.vue?vue&type=script&lang=js&"
export * from "./SitemapCategory.vue?vue&type=script&lang=js&"
import style0 from "./SitemapCategory.vue?vue&type=style&index=0&id=540a974e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a974e",
  null
  
)

export default component.exports